import { useState, useEffect } from "react";

const seedTokens = [
  { type: "CONSTANT", value: "BASE_PRICE", id: "001" },
  { type: "OPERATOR", value: "+", id: "002" },
  { type: "BRACKET", value: "(", id: "003" },
  { type: "PARAMETER", value: "WIDTH", id: "004" },
  { type: "OPERATOR", value: "-", id: "005" },
  { type: "CONSTANT", value: "BASE_WIDTH", id: "006" },
  { type: "BRACKET", value: ")", id: "007" },
  { type: "OPERATOR", value: "*", id: "008" },
  { type: "CONSTANT", value: "PRICE_PER_CM", id: "009" },
];

const SEEDED_CONFIGS = ["111-111", "222-222"];

const useFormula = ({ constants: constantsFromProps, configurationId }) => {
  const [constants, setConstants] = useState([]);

  const initialTokens = SEEDED_CONFIGS.includes(configurationId) ? seedTokens : [];
  const [tokens, setTokens] = useState(initialTokens);
  const [history, setHistory] = useState(
    initialTokens.length > 0 ? [initialTokens] : [],
  );

  const getPrice = ({ parameters }) => {
    if (!tokens || tokens.length === 0) {
      const basePrice = constants?.find((c) => c?.id === "BASE_PRICE");
      return { result: basePrice?.value ?? 0 };
    }
    let functionError = false;
    const expression = tokens
      .map((t) => {
        if (t.type === "CONSTANT") {
          const idx = constants?.findIndex(
            (constant) => constant?.id === t.value,
          );
          if (idx > -1) {
            return constants[idx].value;
          } else functionError = true;
        }

        if (t.type === "NUMBER") {
          const v =
            typeof t.value === "number" ? t.value : String(t.value).trim();
          if (v === "" || Number.isNaN(Number(v))) functionError = true;
          return v;
        }

        if (t.type === "PARAMETER") {
          const idx = parameters?.findIndex((parameter) => {
            return (
              Object.keys(parameter)[0]?.toLowerCase() ===
              t.value?.toLowerCase()
            );
          });
          if (idx > -1) {
            return Object.values(parameters[idx])[0];
          } else functionError = true;
        }
        return t.value;
      })
      .join(" ");
    if (functionError) {
      return { result: 0, error: true };
    }
    try {
      // eslint-disable-next-line no-new-func
      const result = Function(`"use strict"; return (${expression});`)();
      return { result };
    } catch (err) {
      return { result: 0, error: true };
    }
  };

  const onFormulaChange = (nextTokens) => {
    setTokens(nextTokens);
    if (nextTokens.length > 0) {
      setHistory((prev) => {
        const prevStr = prev.length > 0 ? JSON.stringify(prev[0]) : "";
        const nextStr = JSON.stringify(nextTokens);
        if (prevStr === nextStr) return prev;
        return [nextTokens, ...prev];
      });
    }
  };

  const restoreFormula = (historyTokens) => {
    setTokens(historyTokens);
  };

  useEffect(() => {
    setConstants(constantsFromProps);
    // eslint-disable-next-line
  }, [JSON.stringify(constantsFromProps || "")]);

  return { tokens, onFormulaChange, getPrice, history, restoreFormula };
};

export default useFormula;
